import { render, staticRenderFns } from "./AccountClaiming.vue?vue&type=template&id=103f1002&scoped=true"
import script from "./AccountClaiming.vue?vue&type=script&lang=js"
export * from "./AccountClaiming.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "103f1002",
  null
  
)

export default component.exports